import { render, staticRenderFns } from "./table-design-generator.vue?vue&type=template&id=7de79412&"
import script from "./table-design-generator.vue?vue&type=script&lang=js&"
export * from "./table-design-generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports